
import { typeIcon } from '@/utils/partnerLocator'

export default {
  name: 'PartnerTypeBadges',
  props: {
    types: {
      type: Array,
      default: () => [],
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    icon: typeIcon,
  },
}
